
/**
 * CardStylesProcessor - Creates styles for card components
 */
export class CardStylesProcessor {
  static createCardStyles(): string {
    return `
      /* Selection card styles */
      .onexip-calculator-container .border {
        border: 1px solid #e2e8f0 !important;
      }

      .onexip-calculator-container .rounded-lg {
        border-radius: 0.5rem !important;
      }

      .onexip-calculator-container .p-6 {
        padding: 1.5rem !important;
      }

      /* Form card styles */
      .onexip-calculator-container .form-card {
        background-color: white !important;
        border: 1px solid #e2e8f0 !important;
        border-radius: 0.5rem !important;
        overflow: hidden !important;
        margin-bottom: 1rem !important;
      }

      /* Card header styles */
      .onexip-calculator-container [class*="CardHeader"] {
        padding: 1.5rem 1.5rem 0 1.5rem !important;
      }

      .onexip-calculator-container [class*="CardContent"] {
        padding: 1.5rem !important;
      }

      .onexip-calculator-container [class*="CardFooter"] {
        padding: 0 1.5rem 1.5rem 1.5rem !important;
      }
    `;
  }
}
